export const EditChecklistTypes = {
    GET_EDIT_CHECKLIST: "GET_EDIT_CHECKLIST",
    CLEAR_EDIT_CHECKLIST: "CLEAR_EDIT_CHECKLIST",

}